/*global kakao*/
import { Modal } from 'antd';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import Const from '../const';
import {getNotifyPosOrderPort, getUseAutoConfirmOrder} from '../lib/module';
import {isSameOrder, removePendingOrder} from '../lib/util/orderUtil';
import {httpExec, httpGet, httpPost, httpPut, httpUrl, makeUrl} from './httpClient';
import Axios from 'axios';
import { reactLocalStorage } from 'reactjs-localstorage';
import util from "util";
import {modalStyle, orderStatusCode} from '../lib/util/codeUtil';

const postDataAsync = async (url, data) => {
  try {
    const res = await httpPost(url, [], data);
    if (res.result !== 'SUCCESS' || res.data !== 'SUCCESS') {
      return res.data;
    }
    return res.data;
  } catch (e) {
    console.warn('postDataAsync failed. ' + e + ', url:' + url);
    return 'EXCEPTION';
  }
};

// 비밀번호 변경
const changePasswordAsync = async (currentPassword, newPassword) => {
  return await postDataAsync(httpUrl.passwordChange, {
    currentPassword,
    newPassword,
  });
};

// 예치금 충전 자동결제 활성/비활성
const changeAutoChargeAsync = async (flag) => {
  return await postDataAsync(httpUrl.autoChargeUpdate, {
    enabled: flag,
  });
};

// SMS 수신동의
const changeAgreeSmsAsync = async (flag) => {
  return await postDataAsync(httpUrl.frUpdate, {
    agreeSms: flag,
  });
};

// 가맹점 정보 업데이트
const updateFrDataAsync = async (data) => {
  try {
    const res = await httpPost(httpUrl.frUpdate, [], data);
    if (res.result !== 'SUCCESS' || res.data !== 'SUCCESS') {
      return res.data;
    }
    return res.data;
  } catch (e) {
    console.warn('updateFrData failed. ' + e);
    return 'EXCEPTION';
  }
};

const setConsentDocIdAsync = async (frIdx, branchIdx, consentDocId) => {
  return await postDataAsync(httpUrl.setConsentDocId, {
    frIdx,
    branchIdx,
    consentDocId,
  });
};

// 좌표변환
const getCoordinatesAsync = async (roadAddr, jibunAddr) => {
  try {
    let address = roadAddr;
    if (jibunAddr !== '') {
      address = address + '?query2=' + jibunAddr;
    }
    const res = await httpGet(httpUrl.getGeocode, [address], {});
    if (res.result !== 'SUCCESS') {
    }
    // const result = JSON.parse(res.data.json);

    // if (result.meta.totalCount === 0) {

    //   try {
    //     const kakaoResult = await addressSearchKakao(roadAddr);

    //     const lat = kakaoResult[0];
    //     const lng = kakaoResult[1];

    //     return {
    //       lat,
    //       lng,
    //     };
    //   } catch (e) {
    //     return null;
    //   }
    // }
    const lat = res.data.latitude;
    const lng = res.data.longitude;
    return {
      lat,
      lng,
    };
  } catch (e) {
    console.warn('getCoordinatesAsync failed. ' + e);
    return null;
  }
};

const addressSearchKakao = (address) => {
  const geocoder = new kakao.maps.services.Geocoder();
  return new Promise((resolve, reject) => {
    geocoder.addressSearch(address, function (result, status) {
      if (status === kakao.maps.services.Status.OK) {
        const coords = [result[0].y, result[0].x];
        resolve(coords);
      } else {
        reject(status);
      }
    });
  });
};

const addressConvertKakao = (address) => {
  const geocoder = new kakao.maps.services.Geocoder();
  return new Promise((resolve, reject) => {
    geocoder.addressSearch(address, function (result, status) {
      if (status === kakao.maps.services.Status.OK) {
        if (!result[0].road_address) {
          reject(new Error('undefined road_address'));
        } else {
          resolve(result[0].road_address.address_name);
        }
      } else {
        reject(new Error(status));
      }
    });
  });
};

// 거리 계산
const calcDistanceAsync = async (lat, lng) => {
  try {
    const res = await httpGet(httpUrl.expectDeliveryPrice, [lat, lng], {});
    if (res.result !== 'SUCCESS') {
      return null;
    }
    return {
      lat,
      lng,
      dist: res.data.distance,
      deliveryBasicPrice: res.data.deliveryPriceBasic,
      deliveryAddPrice: res.data.deliveryPriceExtra,
    };
  } catch (e) {
    console.warn('calcDistanceAsync failed. ' + e);
    return null;
  }
};

// 배송비계산
const calcShippingDataAsync = async (roadAddr, jibunAddr) => {
  const data = await getCoordinatesAsync(roadAddr, jibunAddr);
  if (data === null) {
    return null;
  }
  return await calcDistanceAsync(data.lat, data.lng);
};

// 결제변경 목록
const getOrderPaymentListAsync = async () => {
  try {
    const res = await httpGet(httpUrl.orderPaymentList, [], {});
    if (res.result !== 'SUCCESS') {
      return null;
    }
    return res.data;
  } catch (e) {
    console.warn('getOrderPaymentListAsync failed. ' + e);
    return null;
  }
};

// 결제변경 삭제
const removeOrderPaymentAsync = async (orderIdx) => {
  try {
    const res = await httpPost(httpUrl.orderPaymentChecked, [], { orderIdx });
    if (res.result !== 'SUCCESS' || res.data !== 'SUCCESS') {
      return res.data;
    }
    return res.result;
  } catch (e) {
    console.warn('removeOrderPaymentAsync failed. ' + e);
    return 'EXCEPTION';
  }
};

// 결제변경 전체 삭제
const removeAllOrderPaymentAsync = async (list) => {
  let success = 0;
  let fail = 0;
  for (let i = 0; i < list.length; ++i) {
    const row = list[i];
    const result = await removeOrderPaymentAsync(row.idx);
    if (result === 'SUCCESS') {
      ++success;
    } else {
      --fail;
    }
  }
  return { success, fail };
};

// 블라인드 처리
const addBlindAsync = async (riderIdx, memo, fn) => {
  try {
    const res = await httpPost(httpUrl.blindAdd, [], {
      memo,
      riderIdx,
    });
    if (res.result !== 'SUCCESS' || res.data !== 'SUCCESS') {
      return false;
    }
    if (fn !== undefined) {
      fn();
    }
    return true;
  } catch (e) {
    console.warn('addBlindAsync failed. ' + e);
    return false;
  }
};

// 블라인드 처리 유/무 확인
const getBlindAsync = async (frIdx, riderIdx) => {
  try {
    const res = await httpGet(httpUrl.blindGet, [frIdx, riderIdx], {});
    if (res.result !== 'SUCCESS') {
      return null;
    }
    return res.data;
  } catch (e) {
    console.warn('getBlindAsync failed. ' + e);
    return null;
  }
};

// 배달 접수
const createOrderAsync = async (order, silent = false) => {
  try {
    const res = await httpPost(httpUrl.orderCreate, [], order);
    console.info(`createOrderAsync result:${res.result}, data:${res.data}`);
    if (res.result === 'SUCCESS') {
      if (res.data === 'DELIVERY_NOT_ENABLED') {
        if (!silent) {
          Modal.info({
            title: '배달불가',
            content: '현재 배달불가 상태입니다.',
            ...modalStyle,
          });
        }
      } else if(res.data === 'SUCCESS') {
        removePendingOrder(order);
      }
    } else {
      //Do nothing...
    }
    return res.data;
  } catch (e) {
    console.warn('createOrderAsync failed. ' + e);
    return 'EXCEPTION';
  }
};

const createOrderAwaitAsync = async (order) => {

  uuidv4();
  // api 실패로 리덕스에 저장된 주문 다시 create하는 경우 id가 이미 있을 수 있음
  if (!order.id) order['id'] = uuidv4();
  if (!order.orderDate)
    order.orderDate = moment().format('YYYY-MM-DD HH:mm:ss');
  try {
    const res = await httpPost(
      httpUrl.orderAwaitCreate,
      [order.id],
      JSON.stringify(order)
    );
    if (res.result !== 'SUCCESS') {
    }
    return res.data;
  } catch (e) {
    console.warn('createOrderAsync failed. ' + e);
    return 'EXCEPTION';
  }
};

const updateOrderAwaitAsync = async (order) => {
  try {
    const res = await httpPost(
      httpUrl.orderAwaitUpdate,
      [order.id],
      JSON.stringify(order)
    );
    if (res.result !== 'SUCCESS') {
    }
    return res.data;
  } catch (e) {
    console.warn('orderAwaitCreate failed. ' + e);
    return 'EXCEPTION';
  }
};

const deleteOrderAwaitAsync = async (order) => {

  try {
    const res = await httpPost(httpUrl.orderAwaitDelete, [order.id], {});
    if (res.result === 'SUCCESS') {
      removePendingOrder(order);
    }
    return res.data;
  } catch (e) {
    console.warn('createOrderAsync failed. ' + e);
    return 'EXCEPTION';
  }
};

// 배달 취소
const orderCancelByBmOrderCodeAsync = async (orderCode) => {
  try {
    const res = await httpPost(httpUrl.orderCancelByBmOrderCode, [], {
      bmOrderCode: orderCode,
    });
    if (res.result !== 'SUCCESS') {
    }
    return res.data;
  } catch (e) {
    console.warn('cancelOrderAsync failed. ' + e);
    return 'EXCEPTION';
  }
};

// 배달 수정
const updateOrderAsync = async (order) => {
  try {
    const res = await httpPost(httpUrl.orderUpdate, [], order);
    if (res.result !== 'SUCCESS' || res.data !== 'SUCCESS') {
      return res.data;
    }
    return res.result;
  } catch (e) {
    console.warn('updateOrderAsync failed. ' + e);
    return 'EXCEPTION';
  }
};

const changeItemPreparedAsync = async (order) => {
  return await updateOrderAsync({
    idx: order.idx,
    branchIdx: order.branchIdx,
    itemPrepared: !order.itemPrepared,
  });
};

const getCidNumAsync = async (port) => {
  const url = `http://${Const.cidIp}:${Const.cidPort}/GetCIDNumber`;
  try {
    const res = await httpExec('Get', url, {}, true);
    if (res.result !== 'SUCCESS' || res.data !== 'SUCCESS') {
      return res.number;
    } else return '';
  } catch (e) {
    console.warn('updateOrderAsync failed. ' + e);
    return '';
  }
};

//TODO - solmea : 이 함수 통으로 Header.js에서 가져왔다. 모듈화해서 중복코드 제거하자
const getOrderListAsync = async (hideLoading) => {
  try {
    const res = await httpGet(
      httpUrl.orderProcList,
      [
        50,
        1,
        [
          orderStatusCode.order,
          orderStatusCode.assign,
          orderStatusCode.pickup,
        ],
      ],
      {},
      hideLoading
    );
    if (res.result !== 'SUCCESS') {
      return null;
    }
    return res.data.orders;
  } catch (e) {
    return null;
  }
};

const getPosOrderDataAsync = async (
  port,
  allowDuplicates,
  branchIdx,
  userIdx,
  userToken,
  waitingOrders,
  addWaitingOrder
) => {
  let addCount = 0;
  let result = 'SUCCESS';
  const url = `http://${Const.posOrderIp}:${port}/GetPOSOrders`;
  try {
    const res = await httpExec(
      'Post',
      url,
      { branchIdx, userIdx, userToken },
      true
    );
    // 포스피드/배민 설정된 가맹점은 배민 포트 통해서 요청 날리기만 하고 return
    if (
      getNotifyPosOrderPort() === port &&
      typeof global.psBaeminSetting === 'boolean' &&
      global.psBaeminSetting
    )
      return;

    let realtimeWaitingOrders = null;
    if (res.result.toUpperCase() === 'SUCCESS') {
      // 주문 접수
      if (res.list) {
        let activeOrders = null;
        // console.log(`get pos order data, length:${res.list.length}, allowDuplicates:${allowDuplicates}`);
        if (0 < res.list.length) {
          if (!allowDuplicates) {
            //#6139, 기존에 받아온 대기주문 리스트를 이용하니, 폴링타임 시간동안 등록된 대기주문과 동일 비교를 못한다.
            //인자로 받은 waitingOrders는 사용안하고 realtimeWaitingOrders를 사용한다.
            const res = await httpPost(httpUrl.getOrderAwaitList, [], {}, true);

            let orderAwaitlist = [];
            res.data.orderAwaitList.forEach((stringOrder) => {
              orderAwaitlist.push(JSON.parse(stringOrder));
            });

            // console.log('waitingOrders.length:' + waitingOrders.length);
            // console.log('RealTime orderAwaitlist.length:' + orderAwaitlist.length);
            if (0 < orderAwaitlist.length) {
              realtimeWaitingOrders = orderAwaitlist;
            }
          }

          if (getUseAutoConfirmOrder()) {
            //solmea - 자동접수 중일 경우, 동일 주문이면 폐기를 위해 받아옴.
            //성능 이슈가 있으니 최소한으로 호출한다. Header.js에서도 대기주문 가져올 때 같은 이유로 호출하고 있어서 전역으로 저장해서 사용할 수 있었으면 좋겠다.
            activeOrders = await getOrderListAsync(true);
          }
        }

        if (realtimeWaitingOrders == null) {
          realtimeWaitingOrders = waitingOrders;  //실시간으로 받아온것이 없으면 가지고 있는것이라도 사용한다.
          //console.log('Use waitingOrders instead of realtimeWaitingOrders');
        }

        res.list.forEach(async (order) => {
          order.phone = order.phone.replace(/-/g, '');

          let previousOrder = allowDuplicates
            ? null
            : realtimeWaitingOrders.find( (x) => isSameOrder(x, order) );

          //solmea - 아무리봐도 바로위코드와 중복으로 보여 일단 주석, 추후에 문제 없으면 삭제하자
          // if (!allowDuplicates && !previousOrder) {
          //   previousOrder = realtimeWaitingOrders.find(
          //     (x) => isSameOrder(x, order)
          //   );
          // }

          if (!order.destAddr3) {
            try {
              order.destAddr3 = order.destAddr1;
            } catch (e) {}
          }

          if (getUseAutoConfirmOrder()) {
            //자동접수 중일 경우, 동일 주문이면 폐기
            const existsOrder = activeOrders != null ? activeOrders.find((activeOrder) => isSameOrder(order, activeOrder)) : null;
            if (existsOrder) {
              console.log('Found same order. Discard this pos order.');
              return;
            }
          }

          if (previousOrder) {
            console.log('Found same waiting order. Discard this pos order.');
            return;
          }

          const distRes = await calcShippingDataAsync(
            order.destAddr1,
            order.destAddr3
          );

          let taxFreeAmount = 0;
          const memoString = '' + order.memo;

          if (memoString.startsWith('비과세:')) {
            const regex = /비과세:\d{1,}원/;
            const matchList = memoString.match(regex);
            if (matchList.length !== 0) {
              const numRegexList = matchList[0].match(/\d{1,}/);
              if (numRegexList.length !== 0)
                taxFreeAmount = parseInt(numRegexList[0]);
            }
          }

          let orderAwait = {
            orderCode: order.orderCode ? order.orderCode : null,
            custPhone: order.phone,
            destAddr1: order.destAddr1,
            destAddr2: order.destAddr2,
            destAddr3: order.destAddr3,
            orderPrice: order.price,
            orderPayments: [
              {
                paymentMethod: order.paymentMethod,
                paymentAmount: order.price,
                paymentStatus: 1,
                taxFreeAmount: taxFreeAmount,
                remainTaxFreeAmount: taxFreeAmount,
              },
            ],
            custMessage: order.memo,
            isBaeminOrder: order.isBaeminOrder,
            memo: order.isBaeminOrder ? null : 'BLICT',
            basicDeliveryPrice: distRes.deliveryBasicPrice,
            extraDeliveryPrice: distRes.deliveryAddPrice,
            error: false,
          };

          const res = await createOrderAwaitAsync(orderAwait); //TODO ojoomi #6682일감에 따라 d1 정식배포전까지 대기주문 생성은 기존 redis에 write하도록 변경
          /*const res = await createOrderAwaitAtCloudFlareWorker(orderAwait); // 대기주문을 redis => cloudflare d1으로 관리하도록 변경*/

          // api 처리 실패했을 경우 리덕스로 직접 데이터 넣어주기
          if (res?.toUpperCase() !== 'SUCCESS') { //TODO ojoomi d1 정식배포되면 해당라인 삭제
          /*if (res.data.result.toUpperCase() !== 'SUCCESS') {*/
            orderAwait.error = true;
            addWaitingOrder(orderAwait);
          }

          ++addCount;
        });
      }

      // 주문 취소
      if (res.canceledList) {
        res.canceledList.forEach(async (orderCode) => {
          const waitingOrder = waitingOrders.find(
            (order) => order.orderCode === orderCode
          );
          if (waitingOrder) {
            await deleteOrderAwaitAsync(waitingOrder);// TODO ojoomi: redis에 있는 대기주문이 모두 없어지면 이 라인 코드 삭제
            /*await deleteOrderAwaitAtCloudFlareWorker(waitingOrder);*/
          }
        });
      }
    } else {
      result = res.result;
    }
  } catch (e) {
    result = 'EXCEPTION';
    console.warn('getPosOrderDataAsync failed. ' + e);
  }
  return {
    result,
    hasNewOrder: addCount > 0,
  };
};

const updatePosDeliveryStatusAsync = async (port, posOrder) => {
  try {
    const url = `http://${Const.posOrderIp}:${port}/UpdatePOSOrder`;
    const res = await httpExec('Post', url, posOrder, true);
    if (res.result.toUpperCase() === 'SUCCESS') {
      return true;
    } else {
    }
  } catch (e) {
    console.warn('updatePosDeliveryStatusAsync failed. ' + e);
  }
  return false;
};

const getOrderInfoListFromCloudFlareWorker = async () => {
  const userInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
  const branchIdx = userInfo?.branchIdx;
  const frIdx = userInfo?.idx;

  if (
    branchIdx === null ||
    branchIdx === undefined ||
    frIdx === null ||
    frIdx === undefined
  )
    return [];

  try {
    const res = await Axios({
      method: 'post',
      url: `https://${Const.cloudFlareOrderInfoHost}/frCust/list`,
      data: {
        branchIdx,
        frIdx,
      },
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization:
          'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJmckN1c3QiLCJuYW1lIjoibnlhbW55YW1ib3giLCJpYXQiOjE5OTk5OTk5OTl9.70sCIwhGa3umcOfzEkJsu2ow8wYbSfqv2E4lMuk3bkY',
      },
    });
    return res.data.result;
  } catch (e) {
    return { value: null, metaData: null };
  }
};
const getOrderInfoDetailFromCloudFlareWorker = async (frCustId) => {
  const userInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
  const branchIdx = userInfo?.branchIdx;
  const frIdx = userInfo?.idx;

  if (
    branchIdx === null ||
    branchIdx === undefined ||
    frIdx === null ||
    frIdx === undefined
  )
    return null;

  try {
    const res = await Axios({
      method: 'post',
      url: `https://${Const.cloudFlareOrderInfoHost}/frCust/get`,
      data: {
        branchIdx,
        frIdx,
        frCustId,
      },
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization:
          'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJmckN1c3QiLCJuYW1lIjoibnlhbW55YW1ib3giLCJpYXQiOjE5OTk5OTk5OTl9.70sCIwhGa3umcOfzEkJsu2ow8wYbSfqv2E4lMuk3bkY',
      },
    });
    return res.data.result.value;
  } catch (e) {
    return [];
  }
};

const createOrderInfoAtCloudFlareWorker = async (data) => {
  const userInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
  const branchIdx = userInfo?.branchIdx;
  const frIdx = userInfo?.idx;

  if (
    branchIdx === null ||
    branchIdx === undefined ||
    frIdx === null ||
    frIdx === undefined
  )
    return { data: { result: 'INVALID_USER_INFO' } };

  const requestData = {
    branchIdx,
    frIdx,
    frCust: data,
  };
  const res = await Axios({
    method: 'put',
    url: `https://${Const.cloudFlareOrderInfoHost}/frCust/put`,
    data: requestData,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization:
        'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJmckN1c3QiLCJuYW1lIjoibnlhbW55YW1ib3giLCJpYXQiOjE5OTk5OTk5OTl9.70sCIwhGa3umcOfzEkJsu2ow8wYbSfqv2E4lMuk3bkY',
    },
  });
  return res;
};

const createOrderAwaitAtCloudFlareWorker = (order) => {
  try {
    const userInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
    const branchIdx = userInfo?.branchIdx;
    const frIdx = userInfo?.idx;

    if (
        branchIdx === null ||
        branchIdx === undefined ||
        frIdx === null ||
        frIdx === undefined
    )
      return { data: { result: 'INVALID_USER_INFO' } };

    uuidv4();
    // api 실패로 리덕스에 저장된 주문 다시 create하는 경우 id가 이미 있을 수 있음
    if (!order.id) order['id'] = uuidv4();
    if (!order.orderDate)
      order.orderDate = moment().format('YYYY-MM-DD HH:mm:ss');

    const requestData = {
      branchIdx,
      frIdx,
      "orderAwait": order,
    };
    // 비동기로 진행되도록 할 것.
    const res = Axios({
      method: 'put',
      url: `https://${Const.cloudFlareOrderAwaitHost}/orderAwait/d1/create`,
      data: requestData,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization:
            'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC1vcmRlci1hd2FpdCIsIm5hbWUiOiJoZWV3b29rIiwiaWF0IjoxOTk5OTk5OTk5fQ.y-RkBxCTAcqbnJE6jzbur651ktvTVQEajseF6mGOT94',
      },
    });
    return res;
  } catch (e) {
    console.warn('createOrUpdateOrderAwaitCloudflare failed. ' + e);
    return 'EXCEPTION';
  }
};

const editOrderAwaitAtCloudFlareWorker = (order) => {
  try {
    const userInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
    const branchIdx = userInfo?.branchIdx;
    const frIdx = userInfo?.idx;

    if (
        branchIdx === null ||
        branchIdx === undefined ||
        frIdx === null ||
        frIdx === undefined
    )
      return { data: { result: 'INVALID_USER_INFO' } };

    if (!order.orderDate)
      order.orderDate = moment().format('YYYY-MM-DD HH:mm:ss');

    const requestData = {
      branchIdx,
      frIdx,
      "orderAwait": order,
    };
    const res = Axios({
      method: 'post',
      url: `https://${Const.cloudFlareOrderAwaitHost}/orderAwait/d1/edit`,
      data: requestData,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization:
            'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC1vcmRlci1hd2FpdCIsIm5hbWUiOiJoZWV3b29rIiwiaWF0IjoxOTk5OTk5OTk5fQ.y-RkBxCTAcqbnJE6jzbur651ktvTVQEajseF6mGOT94',
      },
    });
    return res;
  } catch (e) {
    console.warn('editOrderAwaitAtCloudFlareWorker failed. ' + e);
    return 'EXCEPTION';
  }
};

const deleteOrderAwaitAtCloudFlareWorker = async (order) => {
  const id = order.id;
  try {
    const userInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
    const branchIdx = userInfo?.branchIdx;
    const frIdx = userInfo?.idx;

    if (
        branchIdx === null ||
        branchIdx === undefined ||
        frIdx === null ||
        frIdx === undefined
    )
      return { data: { result: 'INVALID_USER_INFO' } };

    const requestData = {
      branchIdx,
      frIdx,
      "orderAwait": {
        id,
      },
    };
    const res = await Axios({
      method: 'post',
      url: `https://${Const.cloudFlareOrderAwaitHost}/orderAwait/d1/delete`,
      data: requestData,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization:
            'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC1vcmRlci1hd2FpdCIsIm5hbWUiOiJoZWV3b29rIiwiaWF0IjoxOTk5OTk5OTk5fQ.y-RkBxCTAcqbnJE6jzbur651ktvTVQEajseF6mGOT94',
      },
    });
    if (res.data.result.toUpperCase() === 'SUCCESS') {
      removePendingOrder(order);
    }
    return res;
  } catch (e) {
    console.warn('deleteOrderAwaitAtCloudFlareWorker failed. ' + e);
    return 'EXCEPTION';
  }
};

const getOrderAwaitByIdAtCloudFlareWorker = (id) => {
  try {
    const userInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
    const branchIdx = userInfo?.branchIdx;
    const frIdx = userInfo?.idx;

    if (
        branchIdx === null ||
        branchIdx === undefined ||
        frIdx === null ||
        frIdx === undefined
    )
      return { data: { result: 'INVALID_USER_INFO' } };

    const requestData = {
      "orderAwaitId": id,
    };
    const res = Axios({
      method: 'post',
      url: `https://${Const.cloudFlareOrderAwaitHost}/orderAwait/d1/byID`,
      data: requestData,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization:
            'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC1vcmRlci1hd2FpdCIsIm5hbWUiOiJoZWV3b29rIiwiaWF0IjoxOTk5OTk5OTk5fQ.y-RkBxCTAcqbnJE6jzbur651ktvTVQEajseF6mGOT94',
      },
    });
    return res;
  } catch (e) {
    console.warn('getOrderAwaitByIdAtCloudFlareWorker failed. ' + e);
    return 'EXCEPTION';
  }

};

const getOrderAwaitByBranchIdxFrIdxAtCloudFlareWorker = () => {
  try {
    const userInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
    const branchIdx = userInfo?.branchIdx;
    const frIdx = userInfo?.idx;

    if (
        branchIdx === null ||
        branchIdx === undefined ||
        frIdx === null ||
        frIdx === undefined
    )
      return { data: { result: 'INVALID_USER_INFO' } };

    const requestData = {
      branchIdx,
      frIdx,
    };
    const res = Axios({
      method: 'post',
      url: `https://${Const.cloudFlareOrderAwaitHost}/orderAwait/d1/byBranchIdxAndFrIdx`,
      data: requestData,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization:
            'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC1vcmRlci1hd2FpdCIsIm5hbWUiOiJoZWV3b29rIiwiaWF0IjoxOTk5OTk5OTk5fQ.y-RkBxCTAcqbnJE6jzbur651ktvTVQEajseF6mGOT94',
      },
    });
    return res;
  } catch (e) {
    console.warn('getOrderAwaitByBranchIdxFrIdxAtCloudFlareWorker failed. ' + e);
    return 'EXCEPTION';
  }
};

const saveYIdPw = async (data) => {
  try {
    const res = await Axios.put(`${Const.yUrl}/yId/put`, data, {
      headers: {
        Authorization: `Bearer ${Const.yBearerToken}`,
        'Content-Type': 'application/json',
      },
    });

    return res.data;
  } catch (e) {
    // console.error(e);
    return null;
  }
};

const getYIdPw = async (data) => {
  try {
    const res = await Axios.post(`${Const.yUrl}/yId/get`, data, {
      headers: {
        Authorization: `Bearer ${Const.yBearerToken}`,
        'Content-Type': 'application/json',
      },
    });

    reactLocalStorage.setObject(
      `${Const.appName}#saveYLog`,
      res.data?.value?.로그_저장_여부
    );
    return res.data;
  } catch (e) {
    // console.error(e);
    return null;
  }
};
const deleteYIdPw = async (data) => {
  try {
    const res = await Axios.post(`${Const.yUrl}/yId/del`, data, {
      headers: {
        Authorization: `Bearer ${Const.yBearerToken}`,
        'Content-Type': 'application/json',
      },
    });

    return res.data;
  } catch (e) {
    // console.error(e);
    return null;
  }
};

const getYToken = async (data) => {
  try {
    const res = await Axios.post(`${Const.yUrl}/yToken/get`, data, {
      headers: {
        Authorization: `Bearer ${Const.yBearerToken}`,
        'Content-Type': 'application/json',
      },
    });

    return res.data;
  } catch (e) {
    // console.error(e);
    return null;
  }
};

const saveYToken = async (data) => {
  try {
    const res = await Axios.put(`${Const.yUrl}/yToken/put`, data, {
      headers: {
        Authorization: `Bearer ${Const.yBearerToken}`,
        'Content-Type': 'application/json',
      },
    });

    return res.data;
  } catch (e) {
    // console.error(e);
    return null;
  }
};

const yogiyoLogin = async (data) => {
  try {
    const res = await Axios.post(`${Const.yogiyoUrl}/1/auth/form`, data, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    try {
      putYLog({
        action: Y_LOG_ACTION_CODE.LOGIN,
        yId: data.username,
        yPw: data.password,
        code: null,
        data: res.data,
        result: '성공',
      });
    } catch (e) {}

    return res.data;
  } catch (e) {
    // console.error(e);
    try {
      putYLog({
        action: Y_LOG_ACTION_CODE.LOGIN,
        yId: data.username,
        yPw: data.password,
        code: null,
        data: e?.response?.data,
        result: '실패',
      });
    } catch (e) {}
    return null;
  }
};

const yogiyoOrderInfo = async (orderCode, yToken) => {
  try {
    const res = await Axios.get(`${Const.yogiyoUrl}/1/deliveries/${orderCode}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${yToken}`,
      },
    });

    putYLog({
      action: Y_LOG_ACTION_CODE.GET_ORDER_INFO,
      code: null,
      data: res.data,
      result: '성공',
    });

    return res.data;
  } catch (e) {
    // console.error(e);
    putYLog({
      action: Y_LOG_ACTION_CODE.GET_ORDER_INFO,
      code: null,
      data: e.response.data,
      result: '실패',
    });

    return null;
  }
};

const putYOrder = async (data) => {
  try {
    const res = await Axios.put(`${Const.yUrl}/yOrder/put`, data, {
      headers: {
        Authorization: `Bearer ${Const.yBearerToken}`,
        'Content-Type': 'application/json',
      },
    });

    return res.data;
  } catch (e) {
    return null;
  }
};

const getYOrder = async (yOrderId) => {
  try {
    console.log(`${Const.yUrl}/yOrder/put`);
    const res = await Axios.post(`${Const.yUrl}/yOrder/get`, {
      yOrderId:yOrderId,
    }, {
      headers: {
        Authorization: `Bearer ${Const.yBearerToken}`,
        'Content-Type': 'application/json',
      },
    });

    // console.log(res);
    return res.data;
  } catch (e) {
    // console.error(e);
    return null;
  }
};


const yogiyoOrderComplete = async (orderCode, yToken) => {
  try {
    const res = await Axios.put(
      `${Const.yogiyoUrl}/1/deliveries/${orderCode}/state`,
      { state: 'CLOSED' },
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${yToken}`,
        },
      }
    );

    if (res?.data?.state === 'CLOSED') {
      putYLog({
        action: Y_LOG_ACTION_CODE.Y_ORDER_COMPLETE,
        code: null,
        data: { data: res.data, orderCode },
        result: '성공',
      });
    } else {
      putYLog({
        action: Y_LOG_ACTION_CODE.Y_ORDER_COMPLETE,
        code: null,
        data: { data: res.data, orderCode },
        result: '실패',
      });
    }

    return res.data;
  } catch (e) {
    // console.error(e);
    putYLog({
      action: Y_LOG_ACTION_CODE.Y_ORDER_COMPLETE,
      code: null,
      data: e?.response?.data,
      result: '실패',
    });

    return null;
  }
};

const getEventBannerList = async () => {
  try {
    const res = await httpGet(httpUrl.getEventBannerList, [], {});
    return res;
  } catch (e) {
    console.error("getEventBannerList error : ", e);
   return null;
  }
}

const getRouletteInfo = async (eventIdx) => {
  try {
    const res = await httpGet(httpUrl.getRouletteInfo, [eventIdx], {});
    return res;
  } catch (e) {
    console.error("getRouletteInfo error : ", e);
    return null;
  }
}

const playRoulette = async (eventIdx) => {
  try {
    const res = await httpGet(httpUrl.playRoulette, [eventIdx], {});
    return res;
  } catch (e) {
    console.error("playRoulette error : ", e);
    return null;
  }
};

const Y_LOG_POSTER = '가맹점웹';
const Y_LOG_KIND_1 = 'y연동';
const Y_LOG_ACTION_CODE = {
  LOGIN: '로그인',
  GET_ORDER_INFO: 'y 주문정보 조회',
  CONVERT_Y_ORDER_TO_NN_ORDER: 'y 주문 냠냠변환',
  NN_WS_ONCLOSE: '냠냠 웹소켓 onclose',
  NN_WS_ONERROR: '냠냠 웹소켓 onerror',
  NN_WS_ONMESSAGE: '냠냠 웹소켓 onmessage',
  NN_WS_ONOPEN: '냠냠 웹소켓 onopen',
  Y_WS_ONCLOSE: 'y 웹소켓 onclose',
  Y_WS_ONERROR: 'y 웹소켓 onerror',
  Y_WS_ONMESSAGE: 'y 웹소켓 onmessage',
  Y_WS_ONOPEN: 'y 웹소켓 onopen',
  Y_ORDER_COMPLETE: 'y 주문 완료처리',
  Y_WS_PING: 'y 웹소켓 핑',
  NN_WS_PING: '냠냠 웹소켓 핑',
  Y_ORDER_POLLNG: 'y 주문 폴링',
};

const putYLog = async (data) => {
  try {
    const loginInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
    const saveYLog = reactLocalStorage.getObject(`${Const.appName}#saveYLog`);

    if (typeof saveYLog === 'object' || saveYLog === undefined || saveYLog === null) return;
    if (typeof saveYLog === 'boolean' && !saveYLog) return;

    const res = await Axios.put(
      `${Const.yLogUrl}/nnlog/put`,
      {
        poster: Y_LOG_POSTER,
        kind1: Y_LOG_KIND_1,
        kind2: loginInfo?.id,
        nnlog: {
          branchIdx: loginInfo?.branchIdx,
          frId: loginInfo?.id,
          ...data,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${Const.yLogBearerToken}`,
          'Content-Type': 'application/json',
        },
      }
    );
  } catch (e) {
    return null;
  }
};

const yogiyoOrderList = async (params, yToken) => {
  try {
    const res = await Axios.get(
        // status 는 ACCEPTED만 가져오도록 고정
      `${Const.yogiyoUrl}/2/deliveries?from=${params.from}&statuses=ACCEPTED&to=${params.to}`,
      {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${yToken}`,
      },
    });

    // putYLog({
    //   action: Y_LOG_ACTION_CODE.GET_ORDER_INFO,
    //   code: null,
    //   data: res.data,
    //   result: '성공',
    // });

    // console.log(res);
    return res.data;
  } catch (e) {
    // console.error(e);
    // putYLog({
    //   action: Y_LOG_ACTION_CODE.GET_ORDER_INFO,
    //   code: null,
    //   data: e.response.data,
    //   result: '실패',
    // });

    return null;
  }
};

const getRouletteInfoFromAllServer = async (eventIdx) => {
  if (eventIdx === null || eventIdx === undefined || isNaN(eventIdx)) return {
    result: 'INVALID_EVENT_IDX',
  }

  const allServerIps = Const.allServerIp;
  if (!Array.isArray(allServerIps)) return {
    result: 'CONST_CONFIG_ERROR',
  }

  let allRankList = [];

  for (let i = 0; i < allServerIps.length; i++) {
    try {
      const serverIp = allServerIps[i];
      const serverUrl =
          `${Const.serverProtocol}://${serverIp}:${Const.serverPort}/event/roulette/rankList`;

      const res = await Axios.get(serverUrl, {
        params: {
          eventIdx,
        },
        withCredentials: true,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      if (
        res?.data?.result !== 'SUCCESS' ||
        res?.data?.data?.rankList === null ||
        res?.data?.data?.rankList === undefined ||
        !Array.isArray(res?.data?.data?.rankList)
      )
        continue;
      allRankList = allRankList.concat(res?.data?.data?.rankList);
    } catch (e) {
      // console.log(`Error while getting roulette result`, e);
      continue;
    }
  }

  return {
    result: 'SUCCESS',
    data: {
      rankList: allRankList,
    },
  };
};

export {
  changePasswordAsync,
  changeAutoChargeAsync,
  changeAgreeSmsAsync,
  updateFrDataAsync,
  setConsentDocIdAsync,
  getCoordinatesAsync,
  calcDistanceAsync,
  calcShippingDataAsync,
  createOrderAsync,
  orderCancelByBmOrderCodeAsync,
  updateOrderAsync,
  changeItemPreparedAsync,
  getOrderPaymentListAsync,
  removeOrderPaymentAsync,
  removeAllOrderPaymentAsync,
  addBlindAsync,
  getBlindAsync,
  getPosOrderDataAsync,
  getCidNumAsync,
  updatePosDeliveryStatusAsync,
  createOrderAwaitAsync,
  updateOrderAwaitAsync,
  deleteOrderAwaitAsync,
  getOrderInfoListFromCloudFlareWorker,
  getOrderInfoDetailFromCloudFlareWorker,
  createOrderInfoAtCloudFlareWorker,
  saveYIdPw,
  getYIdPw,
  saveYToken,
  getYToken,
  yogiyoLogin,
  yogiyoOrderInfo,
  putYOrder,
  deleteYIdPw,
  getEventBannerList,
  getRouletteInfo,
  playRoulette,
  yogiyoOrderComplete,
  putYLog,
  Y_LOG_POSTER,
  Y_LOG_ACTION_CODE,
  Y_LOG_KIND_1,
  yogiyoOrderList,
  getYOrder,
  getRouletteInfoFromAllServer,
  createOrderAwaitAtCloudFlareWorker,
  editOrderAwaitAtCloudFlareWorker,
  deleteOrderAwaitAtCloudFlareWorker,
  getOrderAwaitByIdAtCloudFlareWorker,
  getOrderAwaitByBranchIdxFrIdxAtCloudFlareWorker,
};
